import React,{useEffect,useState} from "react";
import { useFrame  ,useLoader} from '@react-three/fiber'
import { TextureLoader } from 'three/src/loaders/TextureLoader'
import texture from './images/wallpaperflare.com_wallpaper (13).jpg';
export default function Globe() {
    const colorMap = useLoader(TextureLoader, texture);
    const myMesh =React.useRef();
    useFrame(() => {
        myMesh.current.rotation.y+= 0.001;
    })
    const [screenSize, setScreenSize] = useState('');
    useEffect(() => {
      const width = window.innerWidth;
      if (width < 480) {
        setScreenSize(1)
      } else if (width < 768) {
        setScreenSize(2)
      } else {
        setScreenSize(3)
      }
    }, []);
  useEffect(() => {
    function handleResize() {
      const width = window.innerWidth;
      if (width < 480) {
        setScreenSize(1)
      } else if (width < 768) {
        setScreenSize(2)
      } else {
        setScreenSize(3)
      }
    }

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  
  return (

    <mesh ref={myMesh}>
          <sphereGeometry args={[screenSize,32,32]}/>
          <meshStandardMaterial map={colorMap}/>
    </mesh>
  )
}